// extracted by mini-css-extract-plugin
export default {"highlight":"Highlight__highlight___BkNIs","active":"Highlight__active___zeGNR"};